import React, { memo } from 'react';
import * as deviceUtils from 'detect-mobile-device';
import TinyInput from '../tiny-input';

/**
 * Android 端弹起数字键盘会带上#和*，适合输入电话。
 * IOS 端弹出纯数字
 * @param rest
 * @return {JSX.Element}
 * @constructor
 */
const PhoneInput = rest => {
  if (deviceUtils.isIOS()) {
    return <TinyInput type="number" pattern="\d*" {...rest} />;
  } else {
    return <TinyInput type="tel" {...rest} />;
  }
};

export default memo(PhoneInput);
